import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-big-numbered-list-item',
    templateUrl: './big-numbered-list-item.component.html',
    styleUrls: ['./big-numbered-list-item.component.scss'],
    standalone: false
})
export class BigNumberedListItemComponent {
  @Input() num = 0;
  constructor() { }
}
